import { render, staticRenderFns } from "./Badges_Modal_Info.vue?vue&type=template&id=6bbe2820&"
import script from "./Badges_Modal_Info.vue?vue&type=script&lang=js&"
export * from "./Badges_Modal_Info.vue?vue&type=script&lang=js&"
import style0 from "./Badges_Modal_Info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports